module.exports = __webpack_public_path__ + "img/LandingPage.76d38f19.png";